import {gql} from 'apollo-angular';


export interface DossierContext {
  dossierId: number;
  trainTypeId: number;
  ttpId: number;
  version: number;
  territoryId?: number;
  confirmAction?: boolean;
}

export const dossierContext = gql`
  fragment dossierContext on BasicData {
    dossier {
      id
      version
      ttp {
        id
      }
      trainType {
        id
      }
    }
  }`;

